import { FC } from 'react'

import { Accordion, Info } from 'ui/components'
import { Col, Row } from 'ui/themes/globalStyles'
import { CRBAddress } from '~bank-crb-monitor/types'

export const Address: FC<{ address: CRBAddress }> = ({ address }) => {
  const { street, roomOrSuite, box, city, county, state, postalCode, country } = address

  return (
    <Accordion
      title={`Address: ${street}`}
      bottomPadding="small"
      children={
        <>
          <Row>
            <Col>
              <Info label="Street Address">{street}</Info>
            </Col>
            <Col>
              <Info label="Room / Suite #">{roomOrSuite}</Info>
            </Col>
          </Row>
          <Row>
            <Col>
              <Info label="PO Box">{box}</Info>
            </Col>
            <Col>
              <Info label="City">{city}</Info>
            </Col>
          </Row>
          <Row>
            <Col>
              <Info label="County">{county}</Info>
            </Col>
            <Col>
              <Info label="State/Province">{state}</Info>
            </Col>
          </Row>
          <Row>
            <Col>
              <Info label="ZIP/Postal Code">{postalCode}</Info>
            </Col>
            <Col>
              <Info label="Country">{country}</Info>
            </Col>
          </Row>
        </>
      }
    />
  )
}

//
